import ConfirmDialog from "@/components/ConfirmDialog";

interface UnsavedChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export default function UnsavedChangesDialog({
  open,
  onOpenChange,
  onConfirm,
  title = "Leave without saving?",
  description = "You have unsaved changes. If you leave this page, your changes will be lost.",
  confirmLabel = "Leave",
  cancelLabel = "Keep Editing",
}: UnsavedChangesDialogProps) {
  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      onConfirm={onConfirm}
      title={title}
      description={description}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      variant="destructive"
    />
  );
}
